import { call } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* getDashboard(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.DASHBOARD.GET, action.payload, true);
}

function* getJobStatusCounts(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.DASHBOARD.JOB_STATUS_COUNTS, action.payload, true);
}

export default function* adminDashboardSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.DASHBOARD.GET, getDashboard);
}
